import { BenefeciariesService } from './../../services/benefeciariesComponentService';

import { Component, OnInit } from '@angular/core';

import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { BeneficiaryType } from '../../models/beneficiaryType';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-service-type',
  templateUrl: './add-beneficiaries.component.html',
  styleUrls: ['./add-beneficiaries.component.css'],
})
export class AddbeneficiariesComponent implements OnInit {
  sType: BeneficiaryType;
  isLoading: boolean = false;
  constructor(
    private service: BenefeciariesService,
    private diag: NbDialogRef<AddbeneficiariesComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {
    this.sType = {} as BeneficiaryType;
    this.sType.nameAr = '';
    this.sType.nameEN = '';
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  save() {
    this.isLoading = true;

    this.service.post(this.sType).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم إضافة نوع مستفيد جديد بنجاح', '', { status: 'success', duration: 4000 });
      this.diag.close('true');
    });
  }
}
